// Build from Scratch — Form interactions + photo upload
(function() {
  let scratchPhotos = []; // [{url, name}]
  const DEFAULT_NUDE = '#e4a8b5';
  let colorPalette = [DEFAULT_NUDE];
  let currentHue = 338, currentLight = 60;

  const SCRATCH_STORAGE_KEY = 'tn_scratch_draft';

  function activeJewels() {
    return Array.from(document.querySelectorAll('#jewel-row .is-active .jewel__label')).map(el => el.textContent);
  }

  function saveScratchState() {
    try {
      const state = {
        name: document.getElementById('scratch-name')?.value || '',
        vision: document.getElementById('scratch-vision')?.value || '',
        likes: document.getElementById('scratch-likes')?.value || '',
        dislikes: document.getElementById('scratch-dislikes')?.value || '',
        notes: document.getElementById('scratch-notes')?.value || '',
        photos: scratchPhotos,
        palette: colorPalette,
        shape: document.querySelector('#shape-pick .is-active span:last-child')?.textContent || null,
        length: document.querySelector('#length-pick .is-active')?.textContent || null,
        jewel: activeJewels(),
        prefer: document.querySelector('.prefer-row .is-active .prefer__title')?.textContent || null,
        vibe: document.getElementById('vibe-slider')?.value || '35',
        detail: document.getElementById('detail-slider')?.value || '50'
      };
      localStorage.setItem(SCRATCH_STORAGE_KEY, JSON.stringify(state));
    } catch(e) {}
    refreshScratchSaveState();
  }

  // The four Tali cannot build a set without. Everything else on the builder
  // (jewel tones, the sliders, likes, dislikes, notes, photos) is a refinement.
  function scratchMissing() {
    const missing = [];
    if (!(document.getElementById('scratch-vision')?.value || '').trim()) missing.push('your vision');
    if (!document.querySelector('#shape-pick .is-active')) missing.push('a shape');
    if (!document.querySelector('#length-pick .is-active')) missing.push('a length');
    if (!document.querySelector('.prefer-row .is-active')) missing.push('a preference');
    return missing;
  }

  // Signed-out visitors get an <a> here instead of a <button>, so only gate a real button.
  function refreshScratchSaveState() {
    const missing = scratchMissing();
    const btn = document.getElementById('scratch-addbag');
    if (btn && btn.tagName === 'BUTTON') btn.disabled = missing.length > 0;
    const hint = document.getElementById('scratch-missing');
    if (hint) hint.textContent = missing.length ? 'still needed: ' + missing.join(', ') : '';
  }

  // A blank design name becomes "Luke's Set" off their nail profile username,
  // falling back through profile name then account first name.
  function defaultDesignName() {
    const tn = window.TALISNAILZ || {};
    const who = (tn.profileUsername || tn.profileName || tn.customerName || '').trim();
    if (!who) return 'My Set';
    return who.charAt(0).toUpperCase() + who.slice(1) + "'s Set";
  }

  function restoreScratchState() {
    let state;
    try {
      const raw = localStorage.getItem(SCRATCH_STORAGE_KEY);
      if (!raw) return;
      state = JSON.parse(raw);
    } catch(e) { return; }
    applyScratchState(state);
  }

  // Split out from restoreScratchState so the same code can rehydrate the
  // builder from a bag line as well as from the local draft — see
  // initScratchEdit(). Anything that can fill this shape fills the whole form.
  function applyScratchState(state) {
    if (!state) return;

    const nameField = document.getElementById('scratch-name');
    if (nameField && state.name) nameField.value = state.name;

    const vision = document.getElementById('scratch-vision');
    if (vision && state.vision) vision.value = state.vision;

    const likes = document.getElementById('scratch-likes');
    if (likes && state.likes) likes.value = state.likes;

    const dislikes = document.getElementById('scratch-dislikes');
    if (dislikes && state.dislikes) dislikes.value = state.dislikes;

    const notes = document.getElementById('scratch-notes');
    if (notes && state.notes) notes.value = state.notes;

    if (Array.isArray(state.photos) && state.photos.length) {
      scratchPhotos = state.photos;
      renderThumbs();
    }
    if (Array.isArray(state.palette) && state.palette.length) {
      const isLegacyDefault = state.palette.length === 2 &&
        state.palette[0] === 'hsl(348 64% 72%)' && state.palette[1] === 'hsl(348 70% 33%)';
      colorPalette = isLegacyDefault ? [DEFAULT_NUDE] : state.palette.map(normalizePaletteEntry);
      renderPalette();
    }
    if (state.shape) {
      const btn = Array.from(document.querySelectorAll('#shape-pick .shape-pick__btn')).find(b => b.querySelector('span:last-child')?.textContent === state.shape);
      if (btn) selectShape(btn);
    }
    if (state.length) {
      const btn = Array.from(document.querySelectorAll('#length-pick .chip')).find(b => b.textContent === state.length);
      if (btn) selectLength(btn);
    }
    if (state.jewel) {
      // multi-select; older drafts stored a single capitalized string
      const wanted = (Array.isArray(state.jewel) ? state.jewel : [state.jewel]).map(j => String(j).toLowerCase());
      document.querySelectorAll('#jewel-row .jewel').forEach(b => {
        const label = (b.querySelector('.jewel__label')?.textContent || '').toLowerCase();
        b.classList.toggle('is-active', wanted.some(w => w === label || w.startsWith(label)));
      });
    }
    if (state.prefer) {
      const btn = Array.from(document.querySelectorAll('.prefer-row .prefer')).find(b => b.querySelector('.prefer__title')?.textContent === state.prefer);
      if (btn) selectPrefer(btn);
    }
    if (state.vibe) {
      const s = document.getElementById('vibe-slider');
      if (s) {
        s.value = state.vibe;
        if (state.vibe !== '35') s.classList.add('is-touched');
      }
    }
    if (state.detail) {
      const s = document.getElementById('detail-slider');
      if (s) {
        s.value = state.detail;
        if (state.detail !== '50') s.classList.add('is-touched');
      }
    }
  }

  // ── Editing a build already in the bag ────────────────────────────
  // Arrived from the bag's Edit link. The line's properties are the same
  // thirteen fields saveScratchState() writes, so they map straight back onto a
  // state object and go through the normal restore path.
  //
  // Deliberately reads the bag rather than the local draft: the draft is
  // per-device and is cleared on add-to-cart, so on a second device — or simply
  // the next day — it would be empty or, worse, describe a different design.
  let scratchEditKey = null;

  // The builder writes these when a field was left untouched. Restoring them
  // literally would turn "unanswered" into a real answer and light up the
  // add-to-bag button on a build that is still incomplete.
  const SCRATCH_UNSET = 'Not selected';

  function propOf(props, name) {
    const v = props['_' + name] !== undefined ? props['_' + name] : props[name];
    if (v === undefined || v === null) return '';
    const s = String(v).trim();
    return s === SCRATCH_UNSET ? '' : s;
  }

  function scratchStateFromLine(line) {
    const p = line.properties || {};
    const photos = propOf(p, 'Reference Photos')
      .split('|||').map(u => u.trim()).filter(Boolean)
      .map(url => ({ url: url, name: url.split('/').pop() || 'photo' }));
    const palette = propOf(p, 'Colors').split(',').map(c => c.trim()).filter(Boolean);
    const jewel = propOf(p, 'Jewel Tone').split(',').map(j => j.trim()).filter(Boolean);

    return {
      name: propOf(p, 'Design Name'),
      vision: propOf(p, 'Vision'),
      likes: propOf(p, 'Likes'),
      dislikes: propOf(p, 'Dislikes'),
      notes: propOf(p, 'Final Notes'),
      photos: photos,
      palette: palette,
      shape: propOf(p, 'Shape') || null,
      length: propOf(p, 'Length') || null,
      jewel: jewel,
      prefer: propOf(p, 'Preference') || null,
      vibe: propOf(p, 'Overall Energy') || null,
      detail: propOf(p, 'Texture & Dimension') || null
    };
  }

  async function initScratchEdit() {
    if (!new URLSearchParams(location.search).get('edit')) return false;
    const line = window.TN && window.TN.getEditLine ? await window.TN.getEditLine() : null;
    if (!line) return false; // line left the bag; fall through to the normal draft
    scratchEditKey = line.key;
    applyScratchState(scratchStateFromLine(line));
    refreshScratchSaveState();

    const bagBtn = document.getElementById('scratch-addbag');
    const txt = bagBtn && bagBtn.querySelector('.scr-addbag__text');
    if (txt) txt.textContent = 'update bag';
    return true;
  }

  // ── Drag & Drop ───────────────────────────────────────────────────
  function handleDrop(event) {
    event.preventDefault();
    event.currentTarget.classList.remove('is-over');
    handleFiles(event.dataTransfer.files);
  }
  window.handleDrop = handleDrop;

  async function handleFiles(fileList) {
    const drop = document.getElementById('scratch-drop');
    const statusEl = document.getElementById('upload-status');
    const files = Array.from(fileList).filter(f => f.type.startsWith('image/'));
    if (!files.length) return;

    setUploadStatus(`Uploading ${files.length} photo${files.length > 1 ? 's' : ''}…`);

    let failed = 0;
    let lastError = '';

    for (const file of files) {
      try {
        const tn = window.TALISNAILZ || {};
        const safeName = (tn.profileName || tn.customerName || tn.customerEmail || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'unknown';
        const today = new Date().toISOString().slice(0, 10);
        const result = await window.CloudinaryUpload.upload(file, null, 'talisnailz/' + safeName + '/pending-builds/' + today);
        scratchPhotos.push({ url: result.url, name: file.name, publicId: result.publicId });
        renderThumbs();
        saveScratchState();
      } catch(e) {
        failed++;
        lastError = (e && e.message) || 'Upload failed.';
      }
    }
    // The success line used to run unconditionally, overwriting whatever the
    // catch had just written. A total failure therefore reported "0 photo
    // uploaded ✦" instead of the reason, which made a broken upload look like
    // a successful no-op. Report the real error when nothing landed.
    // Failures are modal-only. "1 uploaded, 1 failed. That photo is over 10MB."
    // is exactly right while the modal is open and exactly wrong sitting on the
    // main builder screen ten minutes later.
    if (failed && !scratchPhotos.length) {
      setUploadStatus(lastError, { modalOnly: true });
    } else if (failed) {
      setUploadStatus(`${scratchPhotos.length} uploaded, ${failed} failed. ${lastError}`, { modalOnly: true });
    } else {
      setUploadStatus(`${scratchPhotos.length} photo${scratchPhotos.length > 1 ? 's' : ''} uploaded ✦`);
    }

    const lb = document.getElementById('scratch-lightbox');
    if (lb && lb.classList.contains('is-open') && scratchPhotos.length) {
      buildScratchLightboxTrack();
      renderScratchLightbox(scratchPhotos.length - 1, true);
    }
  }
  window.handleFiles = handleFiles;

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderThumbs() {
    const dropZone = document.getElementById('scratch-drop');
    const viewAllBtn = document.getElementById('scratch-view-all');
    // The tile on the page: polaroid stack, tapping one opens the lightbox.
    const tile = document.getElementById('scratch-thumbs');
    if (tile) {
      tile.innerHTML = scratchPhotos.map((p, i) =>
        `<div class="scratch__thumb" onclick="event.stopPropagation();openScratchLightbox(${i})">
          <img src="${escHtml(p.url)}" alt="${escHtml(p.name || 'reference photo')}" loading="lazy">
        </div>`
      ).join('');
    }

    // Inside the upload modal: previews only, deliberately NOT clickable.
    // The lightbox is a full-screen layer, so opening it from inside the modal
    // left both on screen at once with no way back to either. Viewing photos is
    // the tile's job on the main screen.
    //
    // These use the inspo-submit-thumb classes rather than scratch__thumb: the
    // scratch one sets no width and centres on the drop zone, which is right for
    // the tile but rendered full-size over the modal. inspo-submit-thumb is a
    // fixed 88px and already has the fanned nth-child offsets.
    const modalThumbs = document.getElementById('scratch-upload-thumbs');
    if (modalThumbs) {
      modalThumbs.innerHTML = scratchPhotos.map((p) =>
        `<div class="inspo-submit-thumb" style="cursor:default;pointer-events:none">
          <img src="${escHtml(p.url)}" alt="${escHtml(p.name || 'reference photo')}" loading="lazy">
        </div>`
      ).join('');
    }
    // has-photos on BOTH drop zones. base.css already hides
    // .inspo-submit-drop__title ("tap to add photos") under this class, so the
    // modal only needed the class it was never being given.
    const hasPhotos = scratchPhotos.length > 0;
    if (dropZone) dropZone.classList.toggle('has-photos', hasPhotos);
    const modalDrop = document.getElementById('scratch-upload-drop');
    if (modalDrop) modalDrop.classList.toggle('has-photos', hasPhotos);
    if (viewAllBtn) viewAllBtn.classList.toggle('is-visible', hasPhotos);
  }

  // Two status lines: one inside the upload modal, one on the tile.
  //
  // The modal line is the real one — it is where the user is looking while
  // uploading, and where an error belongs. The tile line is transient: it must
  // never be left holding a stale count after a delete, or an error from a
  // modal that has since been closed. Pass modalOnly for anything that should
  // not survive on the main screen.
  function setUploadStatus(text, opts) {
    const modalEl = document.getElementById('scratch-upload-status');
    if (modalEl) modalEl.textContent = text;
    const pageEl = document.getElementById('upload-status');
    if (pageEl) pageEl.textContent = (opts && opts.modalOnly) ? '' : text;
  }

  function clearPageUploadStatus() {
    const pageEl = document.getElementById('upload-status');
    if (pageEl) pageEl.textContent = '';
  }

  function openScratchUpload() {
    const m = document.getElementById('scratch-upload-modal');
    if (!m) { document.getElementById('scratch-file').click(); return; }
    m.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    renderThumbs();
  }
  function closeScratchUpload() {
    const m = document.getElementById('scratch-upload-modal');
    if (m) m.style.display = '';
    document.body.style.overflow = '';
    // Whatever the modal was reporting belonged to the modal. Nothing about
    // that session should be left sitting on the builder screen.
    clearPageUploadStatus();
  }
  window.openScratchUpload = openScratchUpload;
  window.closeScratchUpload = closeScratchUpload;

  document.addEventListener('keydown', function (e) {
    const m = document.getElementById('scratch-upload-modal');
    if (e.key === 'Escape' && m && m.style.display === 'flex') closeScratchUpload();
  });

  // ── Scratch lightbox ─────────────────────────────────────────────
  var inspoLbIndex = 0;

  function buildScratchLightboxTrack() {
    const track = document.getElementById('scratch-lightbox-track');
    const dotsWrap = document.getElementById('scratch-lightbox-dots');
    if (!track || !dotsWrap) return;

    let html = '';
    if (scratchPhotos.length > 1) {
      html += `<div class="scratch-lightbox__slide" aria-hidden="true"><img src="${escHtml(scratchPhotos[scratchPhotos.length - 1].url)}" alt="" onclick="event.stopPropagation()"></div>`;
    }
    scratchPhotos.forEach((p) => {
      html += `<div class="scratch-lightbox__slide"><img src="${escHtml(p.url)}" alt="${escHtml(p.name || 'reference photo')}" onclick="event.stopPropagation()"></div>`;
    });
    if (scratchPhotos.length > 1) {
      html += `<div class="scratch-lightbox__slide" aria-hidden="true"><img src="${escHtml(scratchPhotos[0].url)}" alt="" onclick="event.stopPropagation()"></div>`;
    }
    track.innerHTML = html;

    dotsWrap.innerHTML = scratchPhotos.map((_, i) =>
      `<span onclick="event.stopPropagation();scratchLightboxDot(${i})"></span>`
    ).join('');
    dotsWrap.style.display = scratchPhotos.length > 1 ? '' : 'none';

    document.querySelectorAll('#scratch-lightbox .scratch-lightbox__arrow').forEach((a) => {
      a.style.display = scratchPhotos.length > 1 ? '' : 'none';
    });
  }

  function renderScratchLightbox(idx, instant) {
    const track = document.getElementById('scratch-lightbox-track');
    const dots = document.querySelectorAll('#scratch-lightbox-dots span');
    const count = scratchPhotos.length;
    if (!track || count === 0) return;
    const hasClones = track.children.length === count + 2;
    const offset = hasClones ? 1 : 0;
    idx = ((idx % count) + count) % count;
    const trackPos = idx + offset;
    if (instant) {
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + (trackPos * 100) + '%)';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => { track.style.transition = ''; });
      });
    } else {
      track.style.transform = 'translateX(-' + (trackPos * 100) + '%)';
    }
    inspoLbIndex = idx;
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  }

  function scratchLightboxNav(dir) {
    const track = document.getElementById('scratch-lightbox-track');
    const count = scratchPhotos.length;
    if (!track || count < 2) return;
    const hasClones = track.children.length === count + 2;
    const cur = inspoLbIndex;

    if (hasClones && dir === 1 && cur === count - 1) {
      track.style.transform = 'translateX(-' + ((count + 1) * 100) + '%)';
      inspoLbIndex = 0;
      document.querySelectorAll('#scratch-lightbox-dots span').forEach((d, i) => d.classList.toggle('is-active', i === 0));
      const onEnd1 = () => {
        track.removeEventListener('transitionend', onEnd1);
        track.style.transition = 'none';
        track.style.transform = 'translateX(-100%)';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => { track.style.transition = ''; });
        });
      };
      track.addEventListener('transitionend', onEnd1);
      return;
    }
    if (hasClones && dir === -1 && cur === 0) {
      track.style.transform = 'translateX(0%)';
      inspoLbIndex = count - 1;
      document.querySelectorAll('#scratch-lightbox-dots span').forEach((d, i) => d.classList.toggle('is-active', i === count - 1));
      const onEnd2 = () => {
        track.removeEventListener('transitionend', onEnd2);
        track.style.transition = 'none';
        track.style.transform = 'translateX(-' + (count * 100) + '%)';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => { track.style.transition = ''; });
        });
      };
      track.addEventListener('transitionend', onEnd2);
      return;
    }
    renderScratchLightbox(cur + dir, false);
  }
  window.scratchLightboxNav = scratchLightboxNav;

  function scratchLightboxDot(target) {
    renderScratchLightbox(target, true);
  }
  window.scratchLightboxDot = scratchLightboxDot;

  function openScratchLightbox(startIdx) {
    if (!scratchPhotos.length) return;
    buildScratchLightboxTrack();
    renderScratchLightbox(startIdx || 0, true);
    const lb = document.getElementById('scratch-lightbox');
    if (lb) lb.classList.add('is-open');
    document.body.classList.add('scratch-lightbox-open');
  }
  window.openScratchLightbox = openScratchLightbox;

  function closeScratchLightbox(e) {
    if (e) e.stopPropagation();
    const lb = document.getElementById('scratch-lightbox');
    if (lb) lb.classList.remove('is-open');
    document.body.classList.remove('scratch-lightbox-open');
  }
  window.closeScratchLightbox = closeScratchLightbox;

  function scratchLightboxTrash() {
    if (!scratchPhotos.length) return;
    scratchPhotos.splice(inspoLbIndex, 1);
    renderThumbs();
    saveScratchState();
    // The status line was never updated on delete, so it kept reporting the
    // count from before the photo was removed ("1 photo uploaded ✦" with none left).
    setUploadStatus(
      scratchPhotos.length
        ? `${scratchPhotos.length} photo${scratchPhotos.length > 1 ? 's' : ''} uploaded ✦`
        : ''
    );
    if (!scratchPhotos.length) {
      closeScratchLightbox();
      return;
    }
    const nextIdx = inspoLbIndex >= scratchPhotos.length ? scratchPhotos.length - 1 : inspoLbIndex;
    buildScratchLightboxTrack();
    renderScratchLightbox(nextIdx, true);
  }
  window.scratchLightboxTrash = scratchLightboxTrash;

  document.addEventListener('keydown', (e) => {
    const lb = document.getElementById('scratch-lightbox');
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); scratchLightboxNav(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); scratchLightboxNav(1); }
    else if (e.key === 'Escape') { closeScratchLightbox(); }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const track = document.getElementById('scratch-lightbox-track');
    if (!track) return;

    let touchStartX = null, touchStartY = null, touchDragging = false;
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDragging = false;
    }, { passive: true });
    track.addEventListener('touchmove', (e) => {
      if (touchStartX === null) return;
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      if (!touchDragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) touchDragging = true;
      if (touchDragging) e.preventDefault();
    }, { passive: false });
    track.addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (touchDragging && Math.abs(dx) > 40) scratchLightboxNav(dx < 0 ? 1 : -1);
      touchDragging = false;
    }, { passive: true });

    let mouseStartX = null, mouseDragging = false;
    track.addEventListener('mousedown', (e) => {
      mouseStartX = e.clientX;
      mouseDragging = false;
      e.preventDefault();
    });
    document.addEventListener('mousemove', (e) => {
      if (mouseStartX === null) return;
      if (Math.abs(e.clientX - mouseStartX) > 10) mouseDragging = true;
    });
    document.addEventListener('mouseup', (e) => {
      if (mouseStartX === null) return;
      const dx = e.clientX - mouseStartX;
      mouseStartX = null;
      if (mouseDragging && Math.abs(dx) > 40) scratchLightboxNav(dx < 0 ? 1 : -1);
      mouseDragging = false;
    });

    let wheelNet = 0, wheelDeciding = false, wheelLocked = false;
    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (wheelLocked) {
        if (Math.abs(e.deltaX) < 3) wheelLocked = false;
        return;
      }
      wheelNet += e.deltaX;
      if (!wheelDeciding) {
        wheelDeciding = true;
        setTimeout(() => {
          if (Math.abs(wheelNet) > 25) {
            wheelLocked = true;
            scratchLightboxNav(wheelNet > 0 ? 1 : -1);
          }
          wheelNet = 0;
          wheelDeciding = false;
        }, 60);
      }
    }, { passive: false });
  });

  // ── Color Picker ──────────────────────────────────────────────────
  //
  // Two modes over one HSV model:
  //   spectrum — hue on the vertical axis, white → saturated → black across
  //              the horizontal. Whole gamut visible at once.
  //   classic  — saturation/value square for one hue, hue chosen on a strip.
  //
  // Both are pointer-dragged, not click-only, and both write to the same
  // {h,s,v} so switching tabs keeps the current colour.
  //
  // Note this replaces a model that hard-coded saturation at 64%, which made
  // true greys, pastels and vivid colours unreachable.

  // Seeded from DEFAULT_NUDE so the picker opens already on nude — one source
  // of truth, so changing DEFAULT_NUDE moves the preselection with it.
  // (hexToHsv is a hoisted function declaration, so it is callable here.)
  var cp = Object.assign({ mode: 'spectrum' }, hexToHsv(DEFAULT_NUDE) || { h: 347, s: 0.26, v: 0.89 });

  function hslToHex(h, sPct, lPct) {
    var s2 = sPct / 100, l = lPct / 100;
    var a = s2 * Math.min(l, 1 - l);
    var f = function (n) {
      var k = (n + h / 30) % 12;
      var c = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * c).toString(16).padStart(2, '0');
    };
    return '#' + f(0) + f(8) + f(4);
  }

  // Old drafts stored 'hsl(348 64% 72%)' strings — show them as hex.
  function normalizePaletteEntry(c) {
    var m = /^hsl\((\d+)[ ,]+(\d+)%[ ,]+(\d+)%\)$/.exec(String(c).trim());
    return m ? hslToHex(+m[1], +m[2], +m[3]) : c;
  }

  function paletteLabel(color) {
    return color === DEFAULT_NUDE ? 'nude' : color;
  }

  function hsvToRgb(h, s, v) {
    var c = v * s, x = c * (1 - Math.abs(((h / 60) % 2) - 1)), m = v - c, r = 0, g = 0, b = 0;
    if (h < 60)       { r = c; g = x; }
    else if (h < 120) { r = x; g = c; }
    else if (h < 180) { g = c; b = x; }
    else if (h < 240) { g = x; b = c; }
    else if (h < 300) { r = x; b = c; }
    else              { r = c; b = x; }
    return [Math.round((r + m) * 255), Math.round((g + m) * 255), Math.round((b + m) * 255)];
  }

  function hsvToHex(h, s, v) {
    var rgb = hsvToRgb(h, s, v);
    return '#' + rgb.map(function (n) { return n.toString(16).padStart(2, '0'); }).join('');
  }

  function hexToHsv(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(String(hex).trim());
    if (!m) return null;
    var r = parseInt(m[1], 16) / 255, g = parseInt(m[2], 16) / 255, b = parseInt(m[3], 16) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    var h = 0;
    if (d) {
      if (max === r) h = ((g - b) / d) % 6;
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
      if (h < 0) h += 360;
    }
    return { h: h, s: max ? d / max : 0, v: max };
  }

  function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }

  function currentHex() { return hsvToHex(cp.h, cp.s, cp.v); }

  function togglePicker() {
    var picker = document.getElementById('color-picker');
    if (!picker) return;
    picker.hidden = !picker.hidden;
    // Bind on open as well as on DOMContentLoaded. bindDrag is idempotent
    // (data-cp-bound), so this costs nothing and removes any dependence on
    // script/DOM ordering.
    if (!picker.hidden) initPicker();
  }
  window.togglePicker = togglePicker;

  function setMode(mode) {
    cp.mode = mode;
    var stage = document.getElementById('cp-stage');
    if (stage) stage.dataset.mode = mode;
    document.querySelectorAll('.cp__tab').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.mode === mode);
    });
    paintPicker();
  }

  // Push the model out to every surface at once, so the two modes and the
  // hex field can never drift apart.
  function paintPicker() {
    var hex = currentHex();

    var sv = document.getElementById('cp-sv');
    if (sv) sv.style.setProperty('--cp-h', cp.h);

    var svH = document.getElementById('cp-sv-handle');
    if (svH) {
      svH.style.left = (cp.s * 100) + '%';
      svH.style.top = ((1 - cp.v) * 100) + '%';
      svH.style.background = hex;
    }

    var hueH = document.getElementById('cp-hue-handle');
    if (hueH) hueH.style.left = ((cp.h / 360) * 100) + '%';

    // Spectrum x: 0 → white, 0.5 → fully saturated, 1 → black.
    var spH = document.getElementById('cp-spectrum-handle');
    if (spH) {
      var x = cp.v < 1 ? 1 - cp.v / 2 : cp.s / 2;
      spH.style.left = (x * 100) + '%';
      spH.style.top = ((cp.h / 360) * 100) + '%';
      spH.style.background = hex;
    }

    var prev = document.getElementById('cp-preview');
    if (prev) prev.style.background = hex;

    var hexInput = document.getElementById('cp-hex');
    if (hexInput && document.activeElement !== hexInput) hexInput.value = hex;

    var native = document.getElementById('cp-native');
    if (native) native.value = hex;
  }

  // One drag handler for all three surfaces. Pointer capture keeps tracking
  // when the finger or cursor leaves the element mid-drag — the old version
  // was click-only, which is why the bars felt dead.
  function bindDrag(el, onMove) {
    if (!el || el.dataset.cpBound === '1') return;
    el.dataset.cpBound = '1';

    function apply(e) {
      var r = el.getBoundingClientRect();
      onMove(clamp01((e.clientX - r.left) / r.width), clamp01((e.clientY - r.top) / r.height));
      paintPicker();
    }

    el.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      el.setPointerCapture(e.pointerId);
      apply(e);
    });
    el.addEventListener('pointermove', function (e) {
      if (el.hasPointerCapture && el.hasPointerCapture(e.pointerId)) apply(e);
    });
    el.addEventListener('pointerup', function (e) {
      if (el.releasePointerCapture) el.releasePointerCapture(e.pointerId);
    });
  }

  function initPicker() {
    bindDrag(document.getElementById('cp-sv'), function (x, y) {
      cp.s = x;
      cp.v = 1 - y;
    });

    bindDrag(document.getElementById('cp-hue'), function (x) {
      cp.h = x * 360;
    });

    bindDrag(document.getElementById('cp-spectrum'), function (x, y) {
      cp.h = y * 360;
      if (x <= 0.5) { cp.s = x * 2; cp.v = 1; }
      else { cp.s = 1; cp.v = 1 - (x - 0.5) * 2; }
    });

    var hexInput = document.getElementById('cp-hex');
    if (hexInput) {
      hexInput.addEventListener('input', function () {
        var parsed = hexToHsv(hexInput.value);
        if (!parsed) return;
        cp.h = parsed.h; cp.s = parsed.s; cp.v = parsed.v;
        paintPicker();
      });
    }

    var dropper = document.getElementById('cp-dropper');
    if (dropper) {
      // Say which one they're getting rather than leaving it a mystery.
      dropper.title = window.EyeDropper
        ? 'Pick a colour from anywhere on screen'
        : 'Opens your system colour panel — use its magnifier to sample the screen';
    }

    var native = document.getElementById('cp-native');
    if (native) native.addEventListener('input', function () {
      var parsed = hexToHsv(native.value);
      if (!parsed) return;
      cp.h = parsed.h; cp.s = parsed.s; cp.v = parsed.v;
      paintPicker();
    });

    paintPicker();
  }

  function addColor() {
    colorPalette.push(currentHex());
    renderPalette();
    var picker = document.getElementById('color-picker');
    if (picker) picker.hidden = true;
    saveScratchState();
  }
  window.addColor = addColor;

  function addDropperColor(value) {
    if (!value) return;
    colorPalette.push(String(value).toLowerCase());
    renderPalette();
    saveScratchState();
    var picker = document.getElementById('color-picker');
    if (picker) picker.hidden = true;
  }
  window.addDropperColor = addDropperColor;

  async function pickWithDropper() {
    // Chrome/Edge: the cursor becomes a screen-wide sampler.
    if (window.EyeDropper) {
      try {
        var result = await new EyeDropper().open();
        if (result && result.sRGBHex) {
          var parsed = hexToHsv(result.sRGBHex);
          if (parsed) { cp.h = parsed.h; cp.s = parsed.s; cp.v = parsed.v; paintPicker(); }
        }
      } catch (e) {} // Esc — nothing to do
      return;
    }
    // Safari/Firefox have no EyeDropper API by design. The OS colour panel
    // does include a screen magnifier, so route them there instead.
    var native = document.getElementById('cp-native');
    if (native) native.click();
  }
  window.pickWithDropper = pickWithDropper;

  function removePaletteColor(btn) {
    const dots = document.querySelectorAll('#palette-dots .palette__dot');
    const idx = Array.from(dots).indexOf(btn);
    if (idx >= 0) colorPalette.splice(idx, 1);
    renderPalette();
    saveScratchState();
  }
  window.removePaletteColor = removePaletteColor;

  document.addEventListener('DOMContentLoaded', initPicker);

  // All picker buttons go through one delegated listener registered at load
  // time. Per-element binding inside initPicker was fragile: anything that
  // threw earlier in that function silently left the buttons dead.
  document.addEventListener('click', function (e) {
    // On mobile the picker is a centred overlay, so tapping the dimmed
    // backdrop should close it. The check is on the wrapper itself, which
    // only receives the click when the tap missed the panel inside.
    if (e.target && e.target.id === 'color-picker') { e.target.hidden = true; return; }

    var hit = e.target.closest && e.target.closest('#cp-add, #cp-cancel, #cp-dropper, .cp__tab');
    if (!hit) return;

    if (hit.id === 'cp-add') { addColor(); return; }
    if (hit.id === 'cp-cancel') {
      var picker = document.getElementById('color-picker');
      if (picker) picker.hidden = true;
      return;
    }
    if (hit.id === 'cp-dropper') { pickWithDropper(); return; }
    if (hit.classList.contains('cp__tab')) { setMode(hit.dataset.mode); return; }
  });

  function renderPalette() {
    const container = document.getElementById('palette-dots');
    if (!container) return;
    const addBtn = container.querySelector('.palette__add');
    const dotsHtml = colorPalette.map(c =>
      `<span class="palette__item">
        <button class="palette__dot" style="background:${c}" onclick="removePaletteColor(this)" title="remove"><span class="palette__dot-x">×</span></button>
        <span class="palette__label">${paletteLabel(c)}</span>
      </span>`
    ).join('');
    container.innerHTML = dotsHtml;
    container.appendChild(addBtn || Object.assign(document.createElement('button'), {
      className: 'palette__add',
      id: 'palette-add-btn',
      title: 'add a color',
      textContent: '+',
      onclick: togglePicker
    }));
  }

  // ── Shape / Length / Prefer ───────────────────────────────────────
  function selectShape(btn) {
    document.querySelectorAll('#shape-pick .shape-pick__btn').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    saveScratchState();
  }
  window.selectShape = selectShape;

  function selectLength(btn) {
    document.querySelectorAll('#length-pick .chip').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    saveScratchState();
  }
  window.selectLength = selectLength;

  function selectJewel(btn) {
    btn.classList.toggle('is-active'); // multi-select: pick as many tones as u want
    saveScratchState();
  }
  window.selectJewel = selectJewel;

  // ── Save / Reset ──────────────────────────────────────────────────
  function saveScratchDesign() {
    saveScratchState();
    const name = document.getElementById('scratch-name')?.value?.trim();
    window.TN?.showToast(name ? `"${name}" saved ✦` : 'design saved ✦');
  }
  window.saveScratchDesign = saveScratchDesign;

  function openScratchReset() {
    document.getElementById('scratch-reset-modal')?.classList.add('is-open');
  }
  window.openScratchReset = openScratchReset;

  function closeScratchReset() {
    document.getElementById('scratch-reset-modal')?.classList.remove('is-open');
  }
  window.closeScratchReset = closeScratchReset;

  function confirmScratchReset() {
    try { localStorage.removeItem(SCRATCH_STORAGE_KEY); } catch(e) {}
    // strip ?product= / ?inspo_photo= so nothing re-attaches after the reset
    window.location.href = window.location.pathname;
  }
  window.confirmScratchReset = confirmScratchReset;

  function selectPrefer(btn) {
    document.querySelectorAll('.prefer-row .prefer').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    saveScratchState();
  }
  window.selectPrefer = selectPrefer;

  // ── Submit ────────────────────────────────────────────────────────
  async function submitScratchOrder() {
    const variantId = window.BUILDER_VARIANT_ID || 0;
    if (!variantId) {
      window.TN?.showToast("Builder isn't fully set up yet — missing product link.");
      return;
    }

    const tn = window.TALISNAILZ || {};
    const designName = document.getElementById('scratch-name')?.value?.trim() || '';
    const vision = document.getElementById('scratch-vision')?.value || '';
    const likes = document.getElementById('scratch-likes')?.value || '';
    const dislikes = document.getElementById('scratch-dislikes')?.value || '';
    const notes = document.getElementById('scratch-notes')?.value || '';
    const shape = document.querySelector('#shape-pick .is-active span:last-child')?.textContent || 'Not selected';
    const length = document.querySelector('#length-pick .is-active')?.textContent || 'Not selected';
    const jewel = activeJewels().join(', ') || 'Not selected';
    const prefer = document.querySelector('.prefer-row .is-active .prefer__title')?.textContent || 'Not selected';
    const vibe = document.getElementById('vibe-slider')?.value || '50';
    const detail = document.getElementById('detail-slider')?.value || '50';
    const photoUrls = scratchPhotos.map(p => p.url).join('|||');

    // Every field is underscore-prefixed. Shopify hides underscore properties
    // from the cart, checkout and confirmation email while still showing them on
    // the order in the admin, which is the only place Tali reads them. Thirteen
    // lines of brief under a $10 deposit line at checkout was the problem; none
    // of the data is lost, it just stops being customer-facing.
    //
    // The bag renders the two that matter (Shape, Length) explicitly — see
    // sections/main-cart.liquid, which also still reads the old bare names so
    // carts built before this change keep displaying.
    const properties = {
      '_Item Type': 'byo',
      '_Vision': vision || 'Not provided',
      '_Shape': shape,
      '_Length': length,
      '_Jewel Tone': jewel,
      '_Preference': prefer,
      '_Overall Energy': vibe,
      '_Texture & Dimension': detail,
      '_Colors': colorPalette.join(', ')
    };
    properties['_Design Name'] = designName || defaultDesignName();
    if (likes) properties['_Likes'] = likes;
    if (dislikes) properties['_Dislikes'] = dislikes;
    if (photoUrls) properties['_Reference Photos'] = photoUrls;
    if (notes) properties['_Final Notes'] = notes;
    if (tn.customerEmail) properties['_Customer'] = tn.customerEmail;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: properties }]
        })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        if (/sold out|stock/i.test(err.message || '')) {
          window.TN?.showToast("We're at full capacity for custom builds right now — check back soon or email hello@talisnailz.com ✦");
          return;
        }
        throw new Error(err.description || 'Add to cart failed');
      }

      // Editing replaces the line it came from. Done after the add, never
      // before, so a failure above leaves the original build in the bag.
      if (scratchEditKey) {
        const added = await res.json().catch(() => null);
        const addedKey = added && added.items && added.items[0] && added.items[0].key;
        // An edit that changed nothing merges back into the same line and
        // doubles it; removing that key would delete the build outright.
        if (addedKey && addedKey === scratchEditKey) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: scratchEditKey, quantity: 1 })
          }).catch(() => {});
        } else {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: scratchEditKey, quantity: 0 })
          }).catch(() => {});
        }
      }

      try { localStorage.removeItem(SCRATCH_STORAGE_KEY); } catch(e) {}
      // flip the pill to its oxblood "added to bag" state before heading to the cart
      const bagBtn = document.getElementById('scratch-addbag');
      if (bagBtn) {
        bagBtn.classList.add('is-added');
        const txt = bagBtn.querySelector('.scr-addbag__text');
        if (txt) txt.textContent = scratchEditKey ? 'bag updated' : 'added to bag';
      }
      await window.TN?.syncCartToServer?.();
      // Awaited, not fired and forgotten: this page redirects to the bag 700ms
      // from now, which would wipe the pop-up before anyone read it. An edit is
      // skipped, same as on the product page.
      if (!scratchEditKey) await window.TN?.maybeCapacityPopup?.();
      setTimeout(() => { window.location.href = '/cart'; }, 700);
    } catch(e) {
      window.TN?.showToast('Something went wrong adding your design to the bag. Please email hello@talisnailz.com');
    }
  }
  window.submitScratchOrder = submitScratchOrder;

  async function attachIncomingProduct() {
    const params = new URLSearchParams(location.search);
    const handle = params.get('product');
    if (!handle) return;
    try {
      const res = await fetch(`/products/${handle}.json`);
      if (!res.ok) return;
      const data = await res.json();
      const p = data.product;
      if (!p || !p.images || !p.images[1]) return;
      if (scratchPhotos.some(ph => ph.url === p.images[1].src)) return;
      scratchPhotos.push({ url: p.images[1].src, name: p.title });
      renderThumbs();
      saveScratchState();
      const statusEl = document.getElementById('upload-status');
      if (statusEl) statusEl.textContent = `${p.title} attached as inspo ✦`;
    } catch (e) {}
  }

  function attachIncomingInspo() {
    const params = new URLSearchParams(location.search);
    const url = params.get('inspo_photo');
    if (!url) return;
    const alt = params.get('inspo_alt') || 'Inspo reference';
    if (scratchPhotos.some(p => p.url === url)) return;
    scratchPhotos.push({ url: url, name: alt });
    renderThumbs();
    saveScratchState();
    const statusEl = document.getElementById('upload-status');
    if (statusEl) statusEl.textContent = 'Inspo photo attached ✦';
  }

  document.addEventListener('DOMContentLoaded', function() {
    renderPalette(); // markup ships only the + button; draw the default nude dot
    // The bag line wins over the local draft when editing: the draft may be a
    // newer unrelated design, or missing entirely on another device. It only
    // falls back to the draft if that line has since left the bag.
    initScratchEdit().then(function (editing) { if (!editing) restoreScratchState(); });
    attachIncomingProduct();
    attachIncomingInspo();

    // Show what a blank name will become, so the default is never a surprise.
    const nameEl = document.getElementById('scratch-name');
    if (nameEl) nameEl.placeholder = defaultDesignName();
    refreshScratchSaveState();

    document.getElementById('scratch-name')?.addEventListener('input', saveScratchState);
    document.getElementById('scratch-vision')?.addEventListener('input', saveScratchState);
    document.getElementById('scratch-likes')?.addEventListener('input', saveScratchState);
    document.getElementById('scratch-dislikes')?.addEventListener('input', saveScratchState);
    document.getElementById('scratch-notes')?.addEventListener('input', saveScratchState);
    ['vibe-slider', 'detail-slider'].forEach(id => {
      document.getElementById(id)?.addEventListener('input', function() {
        this.classList.add('is-touched'); // pink knob turns oxblood once adjusted
        saveScratchState();
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeScratchReset();
    });
  });

})();